// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const ADD_OAUTH_LISTENER = Symbol('oauth-listener');

export { ADD_OAUTH_LISTENER };
//# sourceMappingURL=constants.mjs.map
